/**
 * 接続を作る段階の待ち時間を決める。続けて待ち時間切れになるたびに倍にし（8 → 16 → 32 秒）、
 * 接続が開くと元に戻す。常に遅い回線で、永遠に接続できなくなるのを防ぐための上限つき。
 * WebSocket と SSE の両方が同じ規則で待つように、ここに 1 か所だけ置く。
 */

export const DEFAULT_CONNECT_TIMEOUT_MS = 8_000;
export const MAX_CONNECT_TIMEOUT_MS = 32_000;

export type ConnectTimeoutScheduleOptions = {
  baseTimeoutMs?: number;
  maxTimeoutMs?: number;
};

export type ConnectTimeoutSchedule = {
  /** 次の接続の待ち時間（ミリ秒）。 */
  nextTimeoutMs: () => number;
  /** 待ち時間切れを記録し、続けて切れた回数を返す。 */
  markTimedOut: () => number;
  /** 接続が開いたとき。倍にした待ち時間を元に戻す。 */
  markConnected: () => void;
};

export function createConnectTimeoutSchedule({
  baseTimeoutMs = DEFAULT_CONNECT_TIMEOUT_MS,
  maxTimeoutMs = MAX_CONNECT_TIMEOUT_MS,
}: ConnectTimeoutScheduleOptions = {}): ConnectTimeoutSchedule {
  let consecutiveTimeouts = 0;

  return {
    nextTimeoutMs: () => Math.min(baseTimeoutMs * 2 ** consecutiveTimeouts, maxTimeoutMs),
    markTimedOut: () => {
      consecutiveTimeouts += 1;
      return consecutiveTimeouts;
    },
    markConnected: () => {
      consecutiveTimeouts = 0;
    },
  };
}
